import React from 'react'
import { PropertyResponse } from 'components/search/models/property-search-response'
import { MainPropertyView } from '../main-property/MainPropertyView'
import { LeasedPropertyRootView } from 'components/property/shared/leased-property-root-view'

type LeasedPropertyViewProps = {
    land: PropertyResponse
}

export const LeasedPropertyView: React.FC<LeasedPropertyViewProps> = ({ land }) => {
    if (land.isRoot) {
        return <LeasedPropertyRootView land={land} />
    }

    return <MainPropertyView units={land.properties} />
}
